import React from "react";
import { useNavigate } from "react-router-dom";
import Message from "../img/Message.svg";

const AppFooter = ({ id }) => {
  const navigate = useNavigate();
  const handleGetStart = () => {
    if (id) {
      navigate("/AppPricing", { state: { id } });
    } else {
      alert("App ID is missing.");
    }
  };

  const handleClickHome = () => {
    navigate("/"); // replace with your actual route
  };

  const handleClickProduct = () => {
    navigate("/Products"); // replace with your actual route
  };

  return (
    <div className="w-full bg-[#4C3A68] py-10">
      <div className="flex flex-col items-center px-4">
        {/* Support Email */}
        <div className="flex items-center gap-2 mb-4 w-full max-w-7xl">
          <img src={Message} alt="" className="w-6 h-6" />
          <h1 className="text-white " style={{ fontSize: "18px" }}>
            support@gksinfotech.com
          </h1>
        </div>

        {/* Divider */}
        <div className="w-full max-w-7xl border-b border-white mb-4"></div>

        {/* Footer Content */}
        <div className="w-full flex justify-center">
          <div className="w-full max-w-7xl flex flex-wrap gap-6 md:gap-10 justify-start">
            {/* App Description */}
            <div className="flex-shrink-0 flex flex-col w-full sm:w-[48%]  lg:w-[35%]">
              <h1 className="text-2xl font-extrabold font-inter text-white">
                Marketplace
              </h1>
              <p
                className="text-white font-inter mt-2"
                style={{ textAlign: "justify" }}
              >
                Marketplace is your all-in-one destination for innovative,
                purpose-driven applications that empower individuals, teams, and
                organizations. From gaining self-awareness, making smarter
                decisions, staying organized and to managing service requests
                efficiently via Onzitr—Marketplace brings it all together in a
                unified, secure platform. Discover, deploy, and grow with the
                tools that work for you.
              </p>
            </div>

            <div className="w-[45%] sm:w-[30%] md:w-40"></div>

            {/* Spacer (can be removed or kept if needed) */}
            <div className="sm:hidden flex w-full border-b border-white"></div>

            {/* Quick Links Column 1 */}
            <div className="flex-shrink-0 flex flex-col w-[45%] sm:w-[30%] md:w-40 text-white font-inter text-left gap-2">
              <h1 className="cursor-pointer" onClick={handleClickHome}>
                Home
              </h1>
              <h1
                className="cursor-pointer"
                onClick={() =>
                  window.open("https://onzitr.com/about.html", "_blank")
                }
              >
                About Us
              </h1>
              <h1 className="cursor-pointer" onClick={handleClickProduct}>
                Products
              </h1>
              <h1
                className="cursor-pointer"
                onClick={() =>
                  window.open("https://onzitr.com/gallery.html", "_blank")
                }
              >
                Gallery
              </h1>
            </div>

            {/* Quick Links Column 2 */}
            <div className="flex-shrink-0 flex flex-col w-[45%] sm:w-[30%] md:w-40 text-white font-inter text-left gap-2">
              <h1
                className="cursor-pointer"
                onClick={() => {
                  navigate("/terms&conditions");
                  window.scrollTo(0, 0);
                }}
              >
                Terms & Conditions
              </h1>
              <h1
                className="cursor-pointer"
                onClick={() => {
                  navigate("/privacypolicy");
                  window.scrollTo(0, 0);
                }}
              >
                Privacy Policy
              </h1>
              <h1
                className="cursor-pointer"
                onClick={() => {
                  navigate("/pricingPolicy");
                  window.scrollTo(0, 0);
                }}
              >
                Pricing Policy
              </h1>

              {/* <h1
                className="cursor-pointer"
                onClick={() => {
                  navigate("/contactUs");
                  window.scrollTo(0, 0);
                }}
              >
                Contact Us
              </h1> */}
            </div>

            {/* Quick Links Column 3 */}
            <div className="flex-shrink-0 flex flex-col w-[45%] sm:w-[30%] md:w-40 text-white font-inter text-left gap-2">
              <h1
                className="cursor-pointer"
                onClick={() =>
                  window.open("https://onzitr.com/refund.html", "_blank")
                }
              >
                Refund Policy
              </h1>
              <h1
                className="cursor-pointer"
                onClick={() =>
                  window.open("https://onzitr.com/faq.html", "_blank")
                }
              >
                FAQ
              </h1>
              <h1
                className="cursor-pointer"
                onClick={() =>
                  window.open("https://onzitr.com/Delete.html", "_blank")
                }
              >
                Delete Onzitr Account
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppFooter;
